import { render } from "./connect-messenger.vue?vue&type=template&id=270002b8&scoped=true"
import script from "./connect-messenger.vue?vue&type=script&setup=true&lang=js"
export * from "./connect-messenger.vue?vue&type=script&setup=true&lang=js"

import "./connect-messenger.vue?vue&type=style&index=0&id=270002b8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270002b8"],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/messenger/connect-messenger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "270002b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('270002b8', __exports__)) {
    console.log('reload')
    api.reload('270002b8', __exports__)
  }
  
  module.hot.accept("./connect-messenger.vue?vue&type=template&id=270002b8&scoped=true", () => {
    console.log('re-render')
    api.rerender('270002b8', render)
  })

}


export default __exports__